/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../global/emotion";
import { IconButton } from "../../_base/_core/IconButton/IconButton.emotion";
import { Text } from "../../_base/_core/Text/Text.emotion";
import { ArrowLeftIcon } from "../../_base/icons/Icon/NavigationIcons";

const headerStyle: Interpolation = {
  alignItems: "center",
  display: "grid",
  gridTemplateAreas: "'back title .'",
  gridTemplateColumns: "auto 1fr 40px",
  width: spacing.full,
};
const titleStyle: Interpolation = {
  gridArea: "title",
  textAlign: "center",
};
const buttonStyle: Interpolation = {
  marginLeft: "-8px",
};

export const EmailHeader = ({
  title,
  onBack,
}: {
  title?: string;
  onBack: () => void;
}) => {
  return (
    <div css={headerStyle}>
      <IconButton
        size="s"
        type="button"
        variant="transparentPrimary"
        css={buttonStyle}
        icon={<ArrowLeftIcon />}
        onClick={onBack}
      />
      <Text type="title" size="l" css={titleStyle}>
        {title}
      </Text>
    </div>
  );
};
